import i18next from "i18next"
import allAPE from "assets/data/nomenclature-dactivites-francaise-naf-rev-2-code-ape.json"

// GENDER FOR PARTNERS
export const VELOCISTE_GENDER = 0
export const HORS_AM_GENDER = 1
export const AM_GENDER = 2
export const COLLECTIVITE_GENDER = 3

export const genderStoreList = [
    //gender : 0 (Vélociste), 1 (HAM), 2 (AM), 3 (Collectivité)
    { id: VELOCISTE_GENDER, value: VELOCISTE_GENDER, label: "partner:storeGender.velociste" },
    { id: HORS_AM_GENDER, value: HORS_AM_GENDER, label: "partner:storeGender.horsAlsaceMoselle" },
    { id: AM_GENDER, value: AM_GENDER, label: "partner:storeGender.alsaceMoselle" },
    { id: COLLECTIVITE_GENDER, value: COLLECTIVITE_GENDER, label: "partner:storeGender.collectivite" }
  ]

// Sort on APE's list
type defaultList = {
  label: string,
  value: string
}

const compare = (a: defaultList, b: defaultList) => {
    if (a.label < b.label) return -1
      if (a.label > b.label) return 1
      return 0
}
  
  
const filteredCompanyAPEList = allAPE.filter((item) => {
    return ["4778C", "7490B", "7010Z", "7312Z", "4741Z", "3092Z", "9411Z", "4511T", "9003B", "4791b", "5240W", "4942Z", "7420Z", "8899B", "7112B", "4941A", "8299Z", "2562B", "7912Z", "4673A", "4791Z", "5040Z", "0113Z", "4939B", "8559B", "8559A", "3029Z", "4111F", "4333Z", "7220Z", "9312O", "4799B", "8790A", "9004Z", "8810C", "9329Z", "4620a", "4711B", "4334Z", "3091Z", "8130Z", "7911Z", "4549Z", "4519Z", "7721z", "4634Z", "4540Z", "7721Z", "4510Z", "5220Z", "4791B", "4520B", "9212Z", "4798Z", "8551z", "4519z", "4642Z", "3312Z", "8899A", "5110C", "0504Z", "3230Z", "3832Z", "8230Z", "7739Z", "0000Z", "4321A", "4540Z", "8122Z", "4661Z", "5020Z", "4611Z", "6420Z", "7711A", "5530Z", "1812Z", "4759A", "3320B", "4729Z", "5630Z", "4045Z", "9522Z", "4719B", "5829C", "9512Z", "5520Z", "8560Z", "6831Z", "0524W", "9001Z", "9319Z", "5320Z", "2899B", "4790Z", "3514Z", "7990Z", "4619A", "2720Z", "8121Z", "7311Z", "9609Z", "8551Z", "4767Z", "9529Z", "9320Z", "7430Z", "4764Z", "6201Z", "4531Z", "4752B", "4789Z", "4532Z", "3319Z", "4520A", "2020A", "7729Z", "3299Z", "8219Z", "4619B", "3101Z", "2529Z", "9329Z", "4932Z", "4730Z", "4664Z", "4779Z", "0501Z", "4711F", "4754Z", "5540Z", "4332C", "4752A", "9312Z", "4520A", "4322A", "4771Z", "9524Z", "9499Z", "4690Z", "4774Z", "4649Z", "4778C", "3249Z", "4511Z", "6202A", "4776Z", "7022Z", "7110Z", "7911Z", "7711Z", "4791A", "7721A", "9994Z", "0000Z", "9528Z", "5610C", "3832A", "8790B", "2229A", "4520Z"].includes(item?.fields?.code_naf)
  }).map((item) => ({
    label: `${item?.fields?.code_naf} - ${item?.fields?.intitule_naf_40}`,
    value: item?.fields?.code_naf
  }))
  
export const apeCompanyList = [
    { value: "0000Z", label: "0000Z - " + i18next.t("edit.other_ape_code", { ns: "partner" }) },
    ...filteredCompanyAPEList
  ].sort(compare)
  
  
const filteredAssociationAPEList = allAPE.filter((item) => {
    return ["3832Z", "8810C", "8899B", "9312Z", "9499Z", "9529Z"].includes(item?.fields?.code_naf)
  }).map((item) => ({
    label: `${item?.fields?.code_naf} - ${item?.fields?.intitule_naf_40}`,
    value: item?.fields?.code_naf
  }))
  
  export const apeAssociationList = [
    { value: "0000Z", label: "0000Z - " + i18next.t("edit.other_ape_code", { ns: "partner" }) },
    ...filteredAssociationAPEList
  ].sort(compare)
  
  export const INTER_CHAIN = "INTR"
  
export const partnerChainList = [
    { value: "ALTE", label: "Altermoove" },
    { value: "AUCH", label: "Auchan" },
    { value: "BEAS", label: "Beasty Bike" },
    { value: "BERN", label: "Bernaudeau Cycles" },
    { value: "BOBI", label: "Bobiclou" },
    { value: "BOUT", label: "Bouticycle" },
    { value: "BRDE", label: "Brico dépôt" },
    { value: "CARR", label: "Carrefour" },
    { value: "CACO", label: "Cash converters" },
    { value: "CIBI", label: "Citybike" },
    { value: "CORA", label: "Cora" },
    { value: "CULV", label: "Culture Vélo" },
    { value: "CYCL", label: "Cyclable" },
    { value: "CYCE", label: "Cycles Cesbron" },
    { value: "CYFE", label: "Cycles Feutrier" },
    { value: "CYLI", label: "Cycling" },
    { value: "DVEL", label: "Dvélos" },
    { value: "ECYC", label: "E-Cycle" },
    { value: "EACA", label: "Easy cash" },
    { value: "ECOX", label: "Ecox" },
    { value: "ENVE", label: "Energie Vélo" },
    { value: "FEUV", label: "Feu vert" },
    { value: "GIAN", label: "Giant Stores" },
    { value: "GOSP", label: "Go sport" },
    { value: "GRLE", label: "Groupe Lepape" },
    { value: "HOLL", label: "Holland Bikes" },
    { value: "INTE", label: "Intermarché" },
    { value: INTER_CHAIN, label: "Intersport" },
    { value: "OVEL", label: "Ovélo" },
    { value: "LECL", label: "Leclerc" },
    { value: "LOIS", label: "Loisibike" },
    { value: "MOND", label: "Mondovélo" },
    { value: "MOVE", label: "Movebike" },
    { value: "MYCY", label: "MyCycle" },
    { value: "NARB", label: "Narbonne accessoires" },
    { value: "NAVE", label: "Nati Vert" },
    { value: "NORO", label: "Norauto" },
    { value: "NOZ", label: "Noz" },
    { value: "PROS", label: "ProSport" },
    { value: "SPEC", label: "Specialized" },
    { value: "SYST", label: "Système U" },
    { value: "VEOX", label: "Vélo & Oxygène" },
    { value: "VEST", label: "Vélo Station" },
    { value: "VELO", label: "Vélonaute" },
    { value: "VELA", label: "Véloland" },
    { value: "VEZE", label: "Vélozen" },
    { value: "YAMA", label: "Yamaha" },
    { value: "AUTR", label: "Autre" }
]

export const GIANT_STORES_ORDER_TAGS_URL = "https://bicycode.typeform.com/giant-france "
export const LECLERC_ORDER_TAGS_URL = "https://bicycode.typeform.com/leclerc-sticker"
export const EASY_CASH_ORDER_TAGS_URL = "https://intranet.easycash.fr/?p=Mp&c=Categorie&a=mpArt&dcs=251&quota="
export const CASH_CONVERTER_ORDER_TAGS_URL = "https://bicycode.typeform.com/to/XS91mdMF"
export const PRO_ORDER_TAGS_DEFAULT_URL = "https://b2b.shimano.com/bike/fr/fr/category/cg1B2BEU?query=:relevance:category:cg1B2BEU:brand:Bicycode"
export const BICYCODE_ASSO_ORDER_TAGS_URL = "http://boutique.bicycode.org"
export const YAMAHA_ORDER_TAGS_URL = "https://bicycode.typeform.com/to/P1la6FNK"
